import { arrayOf, shape, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const userDocumentType = arrayOf(
  shape({
    document: shape({
      displayName: string,
      id: string,
    }),
  })
);
